import { useState, useEffect } from 'react';
import { useAuth } from '../components/auth/AuthContext';

export function useManagerPayrollAccess() {
  const { user } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [isOwner,   setIsOwner]   = useState(false);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }

    const storedUser = localStorage.getItem('user');
    const token = storedUser ? JSON.parse(storedUser).token : null;
    fetch('/api/manager-payroll/my-access', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : { hasAccess: false, isOwner: false })
      .then(d => {
        setHasAccess(d.hasAccess ?? false);
        setIsOwner(d.isOwner ?? false);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user]);

  return { hasAccess, isOwner, loading };
}
